import React, { useState } from 'react';
import Modal from 'components/UI/DialogModal';
import MuiButton from 'components/UI/MuiButton';
import { useTranslation } from 'react-i18next';
import { ISelectedEmployeesForInvitation } from 'models/workshopInvitations';
import { CircularProgress, Grid, TableCell, Typography } from '@mui/material';
import { DualListBox } from 'components/UI/DualList';
import useFetchSection from 'hooks/useFetchSection';
import { getInvitations, getUninvitedEmployeesAsync } from 'framework/workshopInvitations';
import { DualGroupsListBox } from 'components/UI/DualList/groups';
import List from 'components/UI/List';
import { AttendedListCells } from 'framework/workshops';
import { Feature } from 'models/api';

interface Props {
  open: boolean;
  loading: boolean;
  id: string;
  feature: Feature;
  onClose: () => void;
  onSubmit: (data: string) => void;
}

const AddWorkshopInvitations2: React.FC<Props> = ({ open, feature, loading, id, onClose, onSubmit }) => {

  const { t } = useTranslation()



  const {
    loading: loadingSection,
    data: Employees,
    permission,
    revalidate,
  } = useFetchSection({
    fetchData: () => getUninvitedEmployeesAsync(`?workshopGroupId=${id}`),
    fetchPermission: () => null!,
    section: "Un invited employees",
  });




  const [selectedEmployees, setSelectedEmployees] = useState<string>('')



  const onSelectedEmployees = (data: ISelectedEmployeesForInvitation[]) => {
    setSelectedEmployees(data.map(item => item.id).join(';'));
  };
  if (loadingSection) return null

  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_add_invitation')}
      maxWidth="lg"
      fullScreen
      children={<div style={{ padding: 2 }} >
        <DualGroupsListBox options={Employees || []} onSelectedEmployees={onSelectedEmployees} />
      </div>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={() => onSubmit(selectedEmployees)}>
            {t('T_send_invitations')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default AddWorkshopInvitations2;
